/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { RequestBuilder } from '../../request-builder';
import { StrictHttpResponse } from '../../strict-http-response';

import { Alerts } from '../../models/alerts';

export interface GetAlerts$Params {}

export function getAlerts(
   http: HttpClient,
   rootUrl: string,
   params?: GetAlerts$Params,
   context?: HttpContext
): Observable<StrictHttpResponse<Alerts>> {
   const rb = new RequestBuilder(rootUrl, getAlerts.PATH, 'get');
   if (params) {
   }

   return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
         return r as StrictHttpResponse<Alerts>;
      })
   );
}

getAlerts.PATH = '/api/alert/list';
